export const routerPaths = {
  main: '/',
  howToBuy: '/howtobuy',
  traits: '/traits',
  terms: '/terms',
  rnct: '/rnct',
  ipfs: '/ipfs',
  voting: '/voting',
  contracts: '/contracts',
  wallet: '/wallet',
  details: '/details/:tokenId',
  burn: '/burn',
};
